// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"ca20a36d","413":"f01af0ef","453":"e42b3741","484":"3ad1ccb6"}[chunkId] + ".chunk.js";
};